import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=585d94a5"
import script from "./MetadataForm.vue?vue&type=script&lang=js"
export * from "./MetadataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports